import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoachMarkComponent } from './CoachMark.component';
import { CoachMarkDirective } from './CoachMark.directive';

export const CoachMarkModuleExports = [CoachMarkComponent, CoachMarkDirective];

@NgModule({
    imports: [CommonModule],
    declarations: [...CoachMarkModuleExports],
    exports: [...CoachMarkModuleExports],
    providers: []
})
export class CoachMarkModule {}
